export default "__VITE_ASSET__17b12acf__"